'use client'
import { useInfiniteQuery } from '@tanstack/react-query'
import useTranslation from 'next-translate/useTranslation'
import InfiniteScroll from 'react-infinite-scroll-component'

import ActivityCardComp from '@/components/ActivityCard'
import { SkeletonLoader } from '@/components/skeletonLoader'

import { api } from '@/services/api'

import { ActivityCard } from '@/types'

function MoreActivities({
  meta,
  category,
  searchq,
  inPerson,
  isOnline,
  children,
}: {
  meta: { currentPage: number; lastPage: number }
  category: string
  searchq: string
  inPerson: boolean
  isOnline: boolean
  children: React.ReactNode
}) {
  const { t } = useTranslation()

  const activityListQuery = useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['activityListQuery', category, searchq, inPerson, isOnline],
    queryFn: async (options) => {
      const { queryKey, pageParam } = options
      const res = await api.getActivities(
        pageParam ? pageParam.toString() : '2',
        'activity',
        queryKey[1],
        queryKey[2],
        queryKey[3],
        queryKey[4],
      )

      if (res.kind === 'ok') {
        return res.data
      }

      return []
    },

    getNextPageParam: (latestPage: { meta: { currentPage: number; lastPage: number } }) => {
      // const { currentPage, lastPage } = latestPage.meta || {}

      // if (!latestPage) {
      //   return undefined
      // }

      const currentPage = latestPage.meta.currentPage || 2
      const lastPage = latestPage.meta.lastPage || 2
      const nextPage = currentPage + 1
      return nextPage <= lastPage ? nextPage : undefined
    },

    staleTime: 1000 * 60 * 5,
  })

  let allActivitiesListData: ActivityCard[] = []

  if (activityListQuery?.data?.pages) {
    for (const page of activityListQuery.data.pages) {
      if (page?.meta?.currentPage > 1) {
        allActivitiesListData = allActivitiesListData.concat(page.data)
      }
    }
  }

  return (
    <InfiniteScroll
      className="flex flex-col items-center justify-center md:block md:flex-none"
      dataLength={allActivitiesListData.length}
      next={activityListQuery.fetchNextPage}
      hasMore={activityListQuery.hasNextPage || false} // Replace with a condition based on your data source
      loader={<SkeletonLoader />}
      // endMessage={<p>end======</p>}
    >
      {children}
      {allActivitiesListData?.map((activity) => {
        return <ActivityCardComp activity={activity} key={`activity-${activity.id}`} />
      })}
      {activityListQuery.isLoading && <SkeletonLoader />}
    </InfiniteScroll>
  )
}

export default MoreActivities
